// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3KnPd","large":"styles_large__1Kd4F"};